import clsx from "clsx";
import { Link } from "react-router-dom";

import { Matrix, Region } from "../../../@types/visualization";
import { htmlEncode } from "../../../util";
import { mapActiveElements, regionMachineName } from "../utils";

type Props = {
  regions: Array<Region>;
  matrix?: Matrix;
  regionLinks: Record<string, string>;
  onMouseEnter: (regionName: string) => void;
  onMouseLeave: () => void;
};

const RegionMenuList = ({
  regions,
  matrix,
  regionLinks,
  onMouseEnter,
  onMouseLeave
}: Props) => {
  const activeElements = mapActiveElements("region", matrix);

  return (
    <>
      {regions
        .filter(element => activeElements[element.style])
        .map((element, index) => {
          const machineName = regionMachineName(element);
          const encodedName = htmlEncode(element.name);
          const link = regionLinks[machineName];
          const itemName = link ? (
            <Link to={link}>{encodedName}</Link>
          ) : (
            <span>{encodedName}</span>
          );
          return (
            <li
              className={clsx(machineName, "fit-content")}
              key={index}
              onMouseEnter={() => onMouseEnter(machineName)}
              onMouseLeave={onMouseLeave}
            >
              <div className={machineName}></div>
              {itemName}
            </li>
          );
        })}
    </>
  );
};

export default RegionMenuList;
